import { Controller, useForm } from "react-hook-form";
import { TextField, Box, Button } from "@mui/material";
import { ReactElement } from "react";

export interface Form {
  firstName: string;
  lastName: string;
  company: string;
  email: string;
  phone: string;
}

interface Props {
  handleOnSubmit: (data: Form) => void;
}

export function SubmissionForm({ handleOnSubmit }: Props): ReactElement {
  const { control, handleSubmit, formState } = useForm<Form>();

  return (
    <Box
      component="form"
      onSubmit={handleSubmit((data) => {
        handleOnSubmit(data);
      })}
    >
      <Controller
        name="firstName"
        rules={{ required: true }}
        control={control}
        render={({ field }) => {
          return (
            <TextField
              margin="normal"
              fullWidth
              id="firstName"
              label="First Name*"
              autoComplete="off"
              autoFocus
              error={formState.errors.firstName ? true : false}
              helperText={
                formState.errors.firstName ? "This field is required" : ""
              }
              {...field}
            />
          );
        }}
      />
      <Controller
        name="lastName"
        rules={{ required: true }}
        control={control}
        render={({ field }) => {
          return (
            <TextField
              margin="normal"
              fullWidth
              id="lastName"
              label="Last Name*"
              autoComplete="off"
              error={formState.errors.lastName ? true : false}
              helperText={
                formState.errors.lastName ? "This field is required" : ""
              }
              {...field}
            />
          );
        }}
      />
      <Controller
        name="company"
        rules={{ required: true }}
        control={control}
        render={({ field }) => {
          return (
            <TextField
              margin="normal"
              fullWidth
              id="company"
              label="Company*"
              autoComplete="off"
              error={formState.errors.company ? true : false}
              helperText={
                formState.errors.company ? "This field is required" : ""
              }
              {...field}
            />
          );
        }}
      />
      <Controller
        name="email"
        rules={{ required: true }}
        control={control}
        render={({ field }) => {
          return (
            <TextField
              margin="normal"
              type="email"
              fullWidth
              id="email"
              label="Email*"
              autoComplete="email"
              error={formState.errors.email ? true : false}
              helperText={
                formState.errors.email ? "This field is required" : ""
              }
              {...field}
            />
          );
        }}
      />
      <Controller
        name="phone"
        rules={{ required: true }}
        control={control}
        render={({ field }) => {
          return (
            <TextField
              margin="normal"
              fullWidth
              type="tel"
              id="phone"
              label="Phone*"
              autoComplete="off"
              error={formState.errors.phone ? true : false}
              helperText={
                formState.errors.phone ? "This field is required" : ""
              }
              {...field}
            />
          );
        }}
      />
      <Box sx={{ mb: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            variant="contained"
            type="submit"
            sx={{
              mt: 4,
              mr: 1,

              backgroundColor: "#0D548A",
              "&:hover": {
                backgroundColor: "#0D548A",
              },
            }}
          >
            Access Now
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
